import AuthRoutes from "./data/AuthRoutes";
import BaseRoutes from "./data/BaseRoutes";

export default [...AuthRoutes, ...BaseRoutes];
